import { useMemo } from 'react';
import { computePreviewStyles } from '../utils/theme';

export default function useThemePreview(formData) {
  const styles = useMemo(() => {
    return computePreviewStyles(formData);
  }, [formData]);

  // Convert to inline style object (removing -- prefix for React)
  const inlineStyles = useMemo(() => {
    const result = {};
    for (const [key, value] of Object.entries(styles)) {
      result[key] = value;
    }
    return result;
  }, [styles]);

  return {
    cssVariables: styles,
    inlineStyles
  };
}
